export default __webpack_public_path__ + "static/media/collections_1.1f7542eb.webp";